module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Bold.74ae95cf.ttf";